/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Register_FailedInputs */

const th_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างการสมัครรับการแจ้งเตือนได้ แต่ลงทะเบียนกับเซิร์ฟเวอร์ไม่สำเร็จ จึงยกเลิกให้แล้ว หากคุณออกจากระบบไปแล้ว กรุณาเข้าสู่ระบบแล้วลองอีกครั้ง`)
};

const en_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription was created but could not be registered with the server, so it has been undone. If you have been signed out, sign in and try again.`)
};

const ja_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読は作成できましたが、サーバーに登録できなかったため取り消しました。サインアウトされている場合は、サインインしてからもう一度お試しください。`)
};

const zh_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅已创建但未能在服务器注册，因此已撤销。若你被登出，请登录后重试。`)
};

const es_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suscripción se creó pero no se pudo registrar en el servidor, así que se ha deshecho. Si se ha cerrado tu sesión, inicia sesión e inténtalo de nuevo.`)
};

const pt_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inscrição foi criada mas não pôde ser registrada no servidor, então foi desfeita. Se sua sessão caiu, entre de novo e tente outra vez.`)
};

const id_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan dibuat tapi tidak bisa didaftarkan ke server, jadi dibatalkan. Jika Anda keluar, masuk lalu coba lagi.`)
};

const fr_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’abonnement a été créé mais n’a pas pu être enregistré auprès du serveur, il a donc été annulé. Si vous avez été déconnecté, reconnectez-vous et réessayez.`)
};

const tl_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagawa ang subscription ngunit hindi naitala sa server, kaya ibinalik ito. Kung na-sign out ka, mag-sign in at subukang muli.`)
};

const vi_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo đăng ký nhưng không ghi được lên máy chủ, nên đã hoàn tác. Nếu bạn bị đăng xuất, hãy đăng nhập rồi thử lại.`)
};

const ko_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독은 만들어졌지만 서버에 등록하지 못해 취소했습니다. 로그아웃되었다면 로그인한 뒤 다시 시도하세요.`)
};

const de_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wurde erstellt, konnte aber nicht beim Server registriert werden und wurde deshalb rückgängig gemacht. Falls du abgemeldet wurdest, melde dich an und versuche es erneut.`)
};

const ru_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка создана, но не зарегистрирована на сервере, поэтому была отменена. Если вас разлогинило, войдите и попробуйте снова.`)
};

const tr_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik oluşturuldu ama sunucuya kaydedilemedi, bu yüzden geri alındı. Oturumunuz kapandıysa giriş yapıp yeniden deneyin.`)
};

const it_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'iscrizione è stata creata ma non registrata sul server, quindi è stata annullata. Se sei stato disconnesso, accedi e riprova.`)
};

const pl_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja została utworzona, ale nie zarejestrowana na serwerze, więc ją cofnięto. Jeśli cię wylogowało, zaloguj się i spróbuj ponownie.`)
};

const uk_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписку створено, але не зареєстровано на сервері, тож її скасовано. Якщо вас розлогінило, увійдіть і спробуйте ще раз.`)
};

const hi_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता बनी पर सर्वर पर दर्ज नहीं हो सकी, इसलिए वापस ले ली गई। अगर आप साइन आउट हो गए हों, तो साइन इन करके फिर कोशिश करें।`)
};

const ar_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُنشئ الاشتراك لكن تعذّر تسجيله على الخادم، فأُلغي. إن خرجت من حسابك، سجّل الدخول وأعد المحاولة.`)
};

const ms_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan dicipta tetapi tidak dapat didaftarkan pada pelayan, jadi ia dibatalkan. Jika anda dilog keluar, log masuk dan cuba lagi.`)
};

const bn_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাবস্ক্রিপশন তৈরি হয়েছিল কিন্তু সার্ভারে নিবন্ধিত হয়নি, তাই ফিরিয়ে নেওয়া হয়েছে। সাইন আউট হয়ে থাকলে সাইন ইন করে আবার চেষ্টা করুন।`)
};

const zh_tw2_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱已建立，但未能在伺服器註冊，因此已復原。若你被登出，請登入後再試。`)
};

const zh_hk2_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱已建立，但未能在伺服器註冊，因此已復原。若你被登出，請登入後再試。`)
};

const ur_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سبسکرپشن بنی مگر سرور پر درج نہ ہو سکی، اس لیے واپس لے لی گئی۔ اگر آپ سائن آؤٹ ہو گئے ہوں تو سائن اِن کر کے دوبارہ کوشش کریں۔`)
};

const fa_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراک ساخته شد اما روی سرور ثبت نشد، پس برگردانده شد. اگر از حساب خارج شده‌اید، وارد شوید و دوباره تلاش کنید.`)
};

const sw_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usajili ulifunguliwa lakini haukuweza kusajiliwa kwenye seva, kwa hivyo umetenduliwa. Kama umetolewa, ingia kisha ujaribu tena.`)
};

const nl_push_register_failed = /** @type {(inputs: Push_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het abonnement is aangemaakt maar kon niet bij de server worden geregistreerd en is daarom teruggedraaid. Als je bent uitgelogd, log dan in en probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "The subscription was created but could not be registered with the server, so it has been undone. If you have been signed out, sign in and try again." |
*
* @param {Push_Register_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_register_failed = /** @type {((inputs?: Push_Register_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Register_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_register_failed(inputs)
	if (locale === "ja") return ja_push_register_failed(inputs)
	if (locale === "zh") return zh_push_register_failed(inputs)
	if (locale === "es") return es_push_register_failed(inputs)
	if (locale === "pt") return pt_push_register_failed(inputs)
	if (locale === "id") return id_push_register_failed(inputs)
	if (locale === "fr") return fr_push_register_failed(inputs)
	if (locale === "tl") return tl_push_register_failed(inputs)
	if (locale === "vi") return vi_push_register_failed(inputs)
	if (locale === "ko") return ko_push_register_failed(inputs)
	if (locale === "de") return de_push_register_failed(inputs)
	if (locale === "ru") return ru_push_register_failed(inputs)
	if (locale === "tr") return tr_push_register_failed(inputs)
	if (locale === "it") return it_push_register_failed(inputs)
	if (locale === "pl") return pl_push_register_failed(inputs)
	if (locale === "uk") return uk_push_register_failed(inputs)
	if (locale === "hi") return hi_push_register_failed(inputs)
	if (locale === "ar") return ar_push_register_failed(inputs)
	if (locale === "ms") return ms_push_register_failed(inputs)
	if (locale === "bn") return bn_push_register_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_push_register_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_push_register_failed(inputs)
	if (locale === "ur") return ur_push_register_failed(inputs)
	if (locale === "fa") return fa_push_register_failed(inputs)
	if (locale === "sw") return sw_push_register_failed(inputs)
	if (locale === "nl") return nl_push_register_failed(inputs)
	return en_push_register_failed(inputs)
});